<div *ngIf="IconType.COUPON === iconType" class="icon notification-coupon">
  <app-icon name="redeem" color="white"></app-icon>
</div>

<div *ngIf="IconType.OCR === iconType" class="icon-container">
  <div class="icon ocr">
    <app-icon name="document_scanner" color="white"></app-icon>
  </div>
  <div class="check">
    <app-icon name="check" color="#33C668" size="20"></app-icon>
  </div>
</div>

<div *ngIf="IconType.OTHER === iconType" class="icon other">
  <app-icon name="info_outlined" color="white"></app-icon>
</div>
